export const priceChangeMockData = () => {
  return [
    {
      sale_price: 2980000,
      changed_at: "2024-04-05T00:00:00.000Z",
    },
    {
      sale_price: 2900000,
      changed_at: "2024-06-15T00:00:00.000Z",
    },
    {
      sale_price: 2855000,
      changed_at: "2024-08-20T00:00:00.000Z",
    },
    {
      sale_price: 2875000,
      changed_at: "2024-09-25T00:00:00.000Z",
    },
  ];
};

export const listingsMockData = () => {
  return [
    {
      listing_id: "9329059862",
      source_name: "James Edition",
      agency: "IMMOBILIARE VISCONTI DI MODRONE",
      sale_price: 2835000,
      sale_currency: "EUR",
      listing_url: null,
    },
    {
      listing_id: "4463457521",
      source_name: "Idealista",
      agency: "Agenzia Milano",
      sale_price: 2200000,
      sale_currency: "EUR",
      listing_url: null,
    },
    {
      listing_id: "3423348291",
      source_name: "Immobiliare",
      agency: "Immobiliare Rossi",
      sale_price: 3150000,
      sale_currency: "EUR",
      listing_url: null,
    },
    {
      listing_id: "2345671234",
      source_name: "James Edition",
      agency: "Agenzia Milano",
      sale_price: 2500000,
      sale_currency: "EUR",
      listing_url: null,
    },
    {
      listing_id: "6543124567",
      source_name: "Idealista",
      agency: "Agenzia Roma",
      sale_price: 2000000,
      sale_currency: "EUR",
      listing_url: null,
    },
    {
      listing_id: "8765432123",
      source_name: "Immobiliare",
      agency: "Immobiliare Milano",
      sale_price: 3800000,
      sale_currency: "EUR",
      listing_url: null,
    },
  ];
};
